module.exports = __webpack_public_path__ + "img/dre.7a12942a.svg";